angular.module('FactoriesModule')
  .factory('SDKTypeFactory', function () {

  var getDisplayName = function(sdkType) {
    var displayName;
    switch (sdkType) {
      case 'legacy':
        displayName = 'Legacy';
        break;
      case 'point':
        displayName = 'Point';
        break;
      case 'radius':
        displayName = 'Radius®';
        break;
      case 'sda':
        displayName = 'SDA';
        break;
      case 'radius3':
        displayName = 'Radius® 3.0+';
        break;
      default:
        displayName = 'UNKNOWN';
        break;
    }
    return displayName;
  }

  return {
    getDisplayName: getDisplayName,
  }
});
